import { useContext, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import BundleWeightForm from '../forms/BundleWeightForm';
import { BundleWeight } from '../../models/bundle';
import { Country, getCountryFullName } from '../../models/country';
import { CreateAction } from '../../store/types/actions';
import { ProviderListItem, ProviderName } from '../../models/provider';
import { Context } from '../../Context';
import { defaultNotify } from '../common/Notify';

const { useForm } = Form;

interface AddBundleWeightProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    countries: Country[];
    providersList: ProviderListItem[];
    error: null | string;
    addBundleWeight: CreateAction<BundleWeight, void>;
}

const AddBundleWeight: React.FC<AddBundleWeightProps> = props => {
    const { open, setOpen, countries, providersList, addBundleWeight, error } = props;
    const { email } = useContext(Context);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = useForm<BundleWeight>();

    const handleOk = async (values: { [key: string]: any }) => {
        const { bundle, country, weights } = values;
        const weightsMap = weights
            .filter((w: { provider: ProviderName; weight: number; }) => w.weight > 0)
            .reduce((
                acc: { provider: ProviderName; weight: number; },
                cur: { provider: ProviderName; weight: number; },
            ) => ({ ...acc, [cur.provider]: cur.weight }), {});
        const newBundleWeight: BundleWeight = {
            bundle,
            country,
            weights: weightsMap,
            updated_by: email,
            updated_at: new Date().toISOString(),
        };
        setConfirmLoading(true);
        await addBundleWeight(newBundleWeight);
        setConfirmLoading(false);
        console.log('error: ', error);
        if (!error) {
            setOpen(false);
            defaultNotify(`${bundle} ${getCountryFullName(country)} added`, '');
        }
    };

    const handleCancel = () => {
        setOpen(false);
    };

    return (
        <Modal
            title="Add Bundle Weight"
            open={open}
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
            getContainer={false}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button form="bundleWeightForm" key="submit" htmlType="submit" type="primary" loading={confirmLoading}>
                    Submit
                </Button>,
            ]}
        >
            <BundleWeightForm
                form={form}
                countries={countries}
                providersList={providersList}
                onFinish={handleOk}
            />
        </Modal>
    );
};

export default AddBundleWeight;
